module.exports = __webpack_public_path__ + "media/images/mobile/abouts/banner-insights-e1b35181144dd9b747d940e0d9b86a90.png";